import { render, staticRenderFns } from "./InvoiceAdditionalInfo.vue?vue&type=template&id=654faf46&"
import script from "./InvoiceAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./InvoiceAdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports